<template>
  <div class="main-footer">
    <div class="main-box">
      <el-row>
        <el-col v-for="(item, index) in footerNav" :key="index" :span="4">
          <dl class="footer-nav-box">
            <dt v-if="item.name!='Join Us'">
              <router-link class="menulink" :to="item.link"> {{item.name}}</router-link>
            </dt>
            <dd
              v-for="(vals, num) in item.child"
              :key="num"
            >
              <router-link class="menulink" :to="vals.link"> {{vals.name}}</router-link>
            </dd>
          </dl>
        </el-col>
        <el-col :span="4" class="text-center">
          <el-image
          style="width: 160px; height: 160px; margin-top: 10px; border: 8px solid #fff;"
          :src="qrcodeImg"
          fit="fill"></el-image>
          <p v-if="__lang=='zh-CN'">扫码关注微信公众号</p>
          <p v-else>Scan and subscribe</p>
        </el-col>
      </el-row>
    </div>
    <div style="width: 100%; padding: 10px 0; border-top:1px solid #666; border-bottom: 1px solid #666;">
      <div class="main-box">
        <el-row>
          <el-col v-for="(item, index) in footerData[__lang].contact" :key="index" :span="6" class="text-center">
            {{item}}
          </el-col>
        </el-row>
      </div>
    </div>
    <div style="width: 100%; padding: 10px 0; font-size: 14px; color: #999;">
      <div class="main-box text-center" v-html="footerData[__lang].copyright"></div>
    </div>
    <el-backtop :bottom="100">
      <div class="goup"></div>
    </el-backtop>
  </div>
</template>

<script>
import { navbar, footerData } from "../data.js";
export default {
  name: "ywfooter",
  data(){
    return {
      qrcodeImg: require('../assets/img/qrcode.jpg'),
      footerData
    };
  },
  computed:{
    menus(){
      return navbar({
        lang:this.$route.params.lang || 'zh-CN'
      })
    },
    footerNav(){
      return this.menus.filter(v=>!!v.child);
    },
    __lang(){
      return this.$route.params.lang || 'zh-CN';
    }
  }
};
</script>

<style lang="less" scoped>
  /deep/.el-backtop{
    width: 65px !important;
    height: 65px !important;
  }
  /deep/.goup {
    width: 65px !important;
    height: 65px !important;
    background: url(../assets/img/top_01.png) center no-repeat;
  }
  .main-footer {
    padding-top: 30px;
    background:#eee url(../assets/img/bg_bottom.png) center bottom no-repeat;
  }
  .footer-nav-box {
    dd,dt,dl{
      margin: 0;
      padding: 0;
    }
    dt {
      font-size: 18px;
      font-weight: 400;
      margin-bottom: 20px;
    }
    dd {
      padding: 6px 0;
      font-size: 14px;
      // line-height: 30px;
    }
  }
</style>
